module.exports = __webpack_public_path__ + "static/media/line-test.6c82f675.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/myaccount/Dashboard/line-test.svg
 ** module id = 1331
 ** module chunks = 0
 **/